/**
 * InvitePage (invite-coming-soon-page) — the client Invite nav tab, a Warm
 * Wellness-Luxe "Coming Soon" page (replaces the CWR 1.2 bare placeholder).
 *
 * The shared ComingSoonPage card: NO interactive elements, NO reward/perk claims
 * (the real referral system is v2, `f-invite-system`).
 *
 * Visual authority: docs/mockups/client-dashboard-redesign/invite-coming-soon.html
 * (Frame 3 "The invitation", confirmed 2026-07-05).
 */
import { ComingSoonPage, type ComingSoonCopy } from './ComingSoonPage';

export const inviteCopy = (businessName: string): ComingSoonCopy => ({
  kicker: "Something's coming",
  title: ['Bring someone', 'with you'],
  body: `Soon you'll be able to invite friends to ${businessName} and share the sessions you love.`,
  foot: 'Arriving in a future update',
});

export function InvitePage() {
  return <ComingSoonPage headerTitle="Invite" testId="invite-page" copy={inviteCopy} />;
}
